/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PluginType } from './PluginType';
import {
    PluginTypeFromJSON,
    PluginTypeFromJSONTyped,
    PluginTypeToJSON,
} from './PluginType';

/**
 * 
 * @export
 * @interface PluginMappingResponse
 */
export interface PluginMappingResponse {
    /**
     * 
     * @type {boolean}
     * @memberof PluginMappingResponse
     */
    hasConfig: boolean;
    /**
     * 
     * @type {string}
     * @memberof PluginMappingResponse
     */
    refId?: string;
    /**
     * 
     * @type {string}
     * @memberof PluginMappingResponse
     */
    pluginId: string;
    /**
     * 
     * @type {PluginType}
     * @memberof PluginMappingResponse
     */
    type: PluginType;
    /**
     * 
     * @type {string}
     * @memberof PluginMappingResponse
     */
    id: string;
}



/**
 * Check if a given object implements the PluginMappingResponse interface.
 */
export function instanceOfPluginMappingResponse(value: object): value is PluginMappingResponse {
    if (!('hasConfig' in value) || value['hasConfig'] === undefined) return false;
    if (!('pluginId' in value) || value['pluginId'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function PluginMappingResponseFromJSON(json: any): PluginMappingResponse {
    return PluginMappingResponseFromJSONTyped(json, false);
}

export function PluginMappingResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PluginMappingResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'hasConfig': json['hasConfig'],
        'refId': json['refId'] == null ? undefined : json['refId'],
        'pluginId': json['pluginId'],
        'type': PluginTypeFromJSON(json['type']),
        'id': json['id'],
    };
}

export function PluginMappingResponseToJSON(value?: PluginMappingResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'hasConfig': value['hasConfig'],
        'refId': value['refId'],
        'pluginId': value['pluginId'],
        'type': PluginTypeToJSON(value['type']),
        'id': value['id'],
    };
}

